module.exports = __webpack_public_path__ + "resource/img/image055Dark.ad9b0ebe.png";